var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tab === 'Past')?_c('past-programs-list',{on:{"programClicked":_vm.selectProgram}}):_c('program-logbook',{attrs:{"current-program":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }